export const FIELDS = {
  ID: 'id',
  PART_ID: 'partId',
  PO_NO: 'pONo',
  PO_ITEM_NO: 'pOItemNo',
  ACCOUNT_ID: 'accountId',
  BUYER: 'buyer',
  QTY: 'qty',
  QTY_AVAILABLE: 'qtyAvailable',
  QTY_RECEIVED: 'qtyReceived',
  QTY_REJECTED: 'qtyRejected',
  WAREHOUSE: 'warehouse',
  WAREHOUSE_ID: 'warehouseId',
  LOCATION: 'location',
  BIN_NUMBER: 'binNumber',
  QTY_BIN: 'qtyBin',
  COST: 'cost',
  RESALE: 'resale',
  LINE_TOTAL: 'lineTotal',
  PREFIX: 'prefix',
  PART_NUMBER: 'partNumber',
  MANUFACTURER_ID: 'manufacturerId',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  REVISION: 'revision',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  PACKAGE: 'package',
  CONDITION: 'condition',
  CONDITION_ID: 'conditionId',
  PHYS_PKG: 'physPkg',
  PIECE_PER_PKG: 'piecePerPkg',
  TEMP_RATING: 'tempRating',
  LEAD_FREE: 'leadFree',
  SIZE: 'size',
  VOLTAGE: 'voltage',
  AMPERAGE: 'amperage',
  RESOLUTION: 'resolution',
  WATTS: 'watts',
  CDM2: 'cdm2',
  COMMENTS: 'comments',
  INCOMING_AIRBILL: 'incomingAirbill',
  DATE_RECEIVED: 'dateReceived',
  RECEIVED_BY_USER_ID: 'receivedByUserId',
  RECEIVED_BY: 'receivedBy',
  INSPECTED_BY_USER_ID: 'inspectedByUserId',
  INSPECTED_BY: 'inspectedBy',
  PART_COST: 'partCost',
  MISC_COST: 'miscCost',
  REFURB_COST: 'refurbCost',
  SHIP_COST: 'shipCost',
  ALLOCATED: 'allocated',
  OLD_BIN: 'oldBin',
  ITEM_NUMBER: 'itemNumber',
  COMPANY: 'company',
  COMPANY_NUMBER: 'companyNumber',
  RECEIVING_ITEM_NUMBER: 'rcvItemNo',
  OFFER_FAX: 'offerFax',
  ALERT_MSG: 'alertMsg',
  ALERT_MESSAGE: 'alertMessage',
  ALERT_TYPE_ID: 'alertTypeId',
  MESSAGE: 'message',
  NCM_REPORT: 'nCMReport',
  DATE_UPDATED: 'dateUpdated',
  UPDATED_BY_USER_ID: 'updatedByUserId',
  INTERNAL_PN: 'internalPN',
  NSN_NUMBER: 'nSNNumber',
  ALT_NUMBER: 'altNumber',
  DESCRIPTION: 'description',
  CONSIGNED: 'consigned',
  CONSIGNED_TO: 'consignedTo',
  CONSIGNED_PERCENT: 'consignedPercent',
  PO_LINE_NO: 'pOLineNo',
  LINE_NUMBER: 'lineNo',
  RECEIVING_ITEM_NO: 'receivingItemNo',
  HARMONIZED_CODE: 'harmonizedCode',
  ORIGIN: 'origin',
  IS_IMAGE: 'isImage',
  IS_DATA: 'isData',
  DISC_INPUT: 'discInput',
  DEFAULT_IMAGE: 'defaultImage',
  TESTED: 'tested',
  TESTED_BY: 'testedBy',
  EXPENSE_ACCOUNT: 'expenseAccount',
  UOM_ID: 'uoMId',
  QTY_RETURNED: 'qtyReturned',
  CORE: 'core',
  WARRANTY: 'warranty',
  END_ITEM_USAGE: 'endItemUsage',
  ADDITIONAL_INFO: 'additionalInfo',
  ALT_MFR: 'altMfr',
  ITEM_TYPE: 'itemType',
  CAGE_CODE: 'cageCode',
  PMA_NUMBER: 'pMANumber',
  EUC_REQUIRED: 'eUC_Required',
  MODEL: 'model',
  QTY_QUARANTINE: 'qtyQuarantine',
  CUSTOMER_PN: 'customerPN',
  QTY_DESTROYED: 'qtyDestroyed',
  RELOCATE: 'relocate',
  SKU: 'sKU',
  QB_ITEM_ID: 'qBItemID',
  QB_SYNCED: 'qBSynced',
  ASSEMBLY_NAME: 'assemblyName',
  PARENT_ASSEMBLY_NAME: 'parentAssemblyName',
  LEAD_TIME: 'leadTime',
  TARIFF_CODE: 'tariffCode',
  DISCOUNT_PRICE_A: 'discountPriceA',
  DISCOUNT_PRICE_B: 'discountPriceB',
  DISCOUNT_PRICE_C: 'discountPriceC',
  DISCOUNT_PRICE_D: 'discountPriceD',
  DISCOUNT_PRICE_PCT_A: 'discountPricePctA',
  DISCOUNT_PRICE_PCT_B: 'discountPricePctB',
  DISCOUNT_PRICE_PCT_C: 'discountPricePctC',
  DISCOUNT_PRICE_PCT_D: 'discountPricePctD',
  DISCOUNT_PRICE_QTY_A: 'discountPriceQtyA',
  DISCOUNT_PRICE_QTY_B: 'discountPriceQtyB',
  DISCOUNT_PRICE_QTY_C: 'discountPriceQtyC',
  DISCOUNT_PRICE_QTY_D: 'discountPriceQtyD',
  LIST_PRICE: 'listPrice',
  ASSET_ACCOUNT: 'assetAccount',
  INCOME_ACCOUNT: 'incomeAccount',
  SPECS: 'specs',
  SHIP_VIA: 'shipVia',
  TRACKING_NO: 'trackingNo',
  BONDED_SPLIT: 'bondedSplit',
  BONDED_INSURANCE: 'bondedInsurance',
  BONDED_BY: 'bondedBy',
  BONDED_AUTH: 'bondedAuth',
  BONDED_START_DATE: 'bondedStartDate',
  BONDED_END_DATE: 'bondedEndDate',
  CONTRAST_RATIO: 'contrastRatio',
  ASPECT_RATIO: 'aspectRatio',
  OPER_TEMP: 'operTemp',
  STOR_TEMP: 'storTemp',
  POLARIZER_TYPE: 'polarizerType',
  BACKLIGHTING: 'backlighting',
  DATA_CONN: 'dataConn',
  BL_CONN: 'bLConn',
  REPLACED_BY_PN: 'replacedByPN',
  APPROVAL_BASIS: 'approvalBasis',
  ENTERED_BY: 'enteredBy',
  WOO_ID: 'wooID',
  WOO_TYPE: 'wooType',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY: 'modifiedBy',
  ACTIVE: 'active',
  INVENTORY_ID: 'inventoryId',
  MANUFACTURER_NAME: 'manufacturerName',
  CLASS_NAME: 'className',
  CATEGORY_NAME: 'categoryName',
  UOM: 'uOM',
  WAREHOUSE_NAME: 'warehouseName',
};
